module.exports = __webpack_public_path__ + "static/media/roll-dice-90.f154b0f0.png";